import React, { useEffect, useState } from "react";
import { Notification } from "../common/Notification";
import { DialogComponent } from "./../common/DialogComponent";
import { IAccountSummary } from "../../store/transaction/types";
import * as httpClient from "../../util/httpClient";
import * as TransactionActions from "../../store/transaction/actions";
import { useDispatch } from "react-redux";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
interface IProps {
    summary: IAccountSummary;
    closeDialog: any;
}
const TransactionEditAccountDialog: React.FunctionComponent<IProps> = (props) => {
    const dispatch = useDispatch();
    const requestRecentTransactions = (offset: number, limit:string, bankAccountTypeId: string, startDate: string, endDate: string, accountId: string) =>
        dispatch(TransactionActions.actionCreators.requestRecentTransactions(offset, limit, bankAccountTypeId, startDate, endDate, accountId));
    const [accountId, setAccountId] = useState("");
    const [nickName, setNickName] = useState("");
    useEffect(() => {
        const cancelBtn: any = document.getElementById("btn-cancel-transaction-edit");
        cancelBtn.addEventListener("click", () => props.closeDialog("cancel"));
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                props.closeDialog("cancel");
            }
        });
        return () => {
            window.removeEventListener("keyup", () => {});
        };
    });

    useEffect(() => {
        setNickName(props.summary["account-nickname"] == null || props.summary["account-nickname"] == "" ? props.summary["account-name"] : props.summary["account-nickname"]);
        setAccountId(props.summary["idf-monitor-id"]);
    }, []);

    const handleInputChange = (event: any) => {
        setNickName(event.target.value);
    };
    const updateAccount = () => {
        // TODO: validate user input nickname

        var postData = { AccountId: accountId + "", nickname: nickName };
        httpClient
            .sendRequest("POST", `api/financial-account/account-nickname`, postData)
            .then((data) => {
                Notification({
                    type: "success",
                    title: "Edit Account",
                    message: "Account nickname updated successfully.",
                    duration: 5,
                });
                requestRecentTransactions(0,"", "", "", "", "");
                props.closeDialog("close");
            })
            .catch(function (error) {
                Notification({
                    type: "error",
                    title: "Edit Account",
                    message: "Account nickname update failed, please try again later.",
                    duration: 5,
                });
            });
    };

    return (
        <React.Fragment>
            <div className="dialog-header">
                <div className="dialog-icon">
                    {" "}
                    <RenderIcons iconName="pen" />
                </div>
                <h1>Edit Account</h1>
            </div>
            <div className="dialog-body">
                <div role="grid" className="data-grid margin-bottom-xs">
                    <div role="row" className="data-row row">
                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                            <div className="data-label" id="label-full-name-display">
                                {"Account Name"}
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-8 col-no-gutter">
                            <div role="gridcell" className="data-value" aria-labelledby="label-full-name-display">
                                {props.summary["account-name"]}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="form-row inline row">
                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                        <label htmlFor="account-nickname">Nickname</label>
                    </div>
                    <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                        <input type="text" className="inputbox" id="account-nickname" placeholder="Nickname" value={nickName} onChange={handleInputChange} />
                    </div>
                </div>
            </div>
            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button
                            type="button"
                            id="btn-cancel-transaction-edit"
                            className="btn-default btn-link btn-no-padding btn-no-border"
                            onClick={() => window.addToDataLayer({ event: "Cancel Editing Transaction Account" })}
                        >
                            <span className="btn-text">Cancel</span>
                        </button>
                    </div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <ul className="list-reset list-inline">
                            <li className="margin-left-xs">
                                <button
                                    type="button"
                                    className="btn-default btn-primary btn-min-width"
                                    onClick={() => {
                                        updateAccount();
                                        window.addToDataLayer({ event: "Save Updated Account Information" });
                                    }}
                                >
                                    <span className="btn-text">Save</span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
export default TransactionEditAccountDialog;
